module.exports = __webpack_public_path__ + "img/16581262_L.1463166d.png";